import template from './upload.html';

export default angular
  .module('doxy.common.components.upload', [])
  .directive('dUpload', function () {
    return {
      template,
      restrict: 'AE',
      scope: {
        model: '=ngModel',
        imageType: '=dImageType',
        institutionId: '=dInstitutionId',
      },
      controller: function (
        $scope,
        $timeout,
        LoopBackAuth,
        s3config,
        apiUrl,
        $injector
      ) {
        import('ng-file-upload').then(() => {
          $injector.loadNewModules(['ngFileUpload']);
          const Upload = $injector.get('Upload');

          $scope.upload = function (files) {
            const file = files && files[0];
            const imageType = $scope.imageType;
            const institutionId = $scope.institutionId;

            if (!file || !imageType || !institutionId) return;

            const params = new URLSearchParams({
              imageType,
              institutionId,
            }).toString();

            $scope.uploadPromise = new Promise((resolve) => {
              const overrideSecret = localStorage.getItem('overrideSecret');
              const overrideIP = localStorage.getItem('overrideIP');
              Upload.upload({
                url: `${apiUrl}/api/Storages/${s3config.waitingRoom}/upload?${params}`,
                headers: {
                  authorization: LoopBackAuth.accessTokenId,
                  ...(overrideSecret &&
                    overrideIP && {
                      'x-override-secret': overrideSecret,
                      'x-override-ip': overrideIP,
                    }),
                },
                file: file,
              }).success(function (data) {
                $timeout(function () {
                  $scope.model = `${data.file.url}?${Date.now()}`;
                  resolve();
                }, 2000);
              });
            });
          };

          $timeout(() => {
            $scope.state = {
              unique: Math.floor((1 + Math.random()) * 0x10000).toString(16),
            };
          });
        });
      },
    };
  }).name;
